module.exports = __webpack_public_path__ + "img/telephonelandingauction.e5b8e402.png";